import React from "react";

import loginCss from "../../css/login/login.css";
import LoginService from "./loginService";
import { Button, InputGroup } from "react-bootstrap";

export default class Login extends React.Component{ 
   constructor(props){ 
      super(props); 
      this.state = {
         cid: '',
         password: '',
         cfAzienda:'',
         ruolo:'',
         showSuccess:false,
         showPassword:false,
         showError:false,
         errorMessage:"",
         successMessage:""
       }
       this.loginService = new LoginService();
       sessionStorage.clear();
   }


   changeText(field, event){
         this.setState({[field]:event.target.value});
   }
   onSubmit(event){
         event.preventDefault();
   }
   loginSuccess(dataResult){
      let user = sessionStorage.getItem('user');
     user = JSON.parse(user);
      this.loginService.getImpostazioni((result) => {
      //  console.log(result)
      });
     this.setState({
                    showSuccess:true,
                    successMessage:"benvenuto: " + this.state.cid,
                    showError:false,
                    errorMessage:""});
     this.props.history.push('/home');
  }
  loginError(error){
     if(error === 0 || error === "0"){
      this.setState({
         showError:true,
         errorMessage:"Errore questo account non può accedere: ",
         showSuccess:false,
         successMessage:""});
     }else{
      this.setState({
                  showError:true,
                  errorMessage:"Errore durante il login: ",
                  showSuccess:false,
                  successMessage:""});
      }
   }
   login(event){
      this.loginService.login(this.state.cid,
                              this.state.password,
                              this.state.cfAzienda,
                              this.loginSuccess.bind(this),
                              this.loginError.bind(this)
                              );
   }

   logout(event){
      sessionStorage.clear();
   }
   getSuccessMessage(){
      if(this.state.showSuccess){
         return ( <div style={{color:"green"}}> {this.state.successMessage} </div> );
      } else {
        return (<div></div>);
      }
   }
   getErrorMessage(){
      if(this.state.showError){
          return ( <div style={{color:"red"}}>{this.state.errorMessage}</div>);
      }else{
         return ( <div></div> );
      }
   }

   render(){ 
      var successMessage = this.getSuccessMessage();
      var errorMessage = this.getErrorMessage();
      return(
         <div className="container" style={{marginTop:"100px", minHeight:"70vh"}}>
             <br/>
            <div className="row">
               <div className="col-md-4 offset-md-4">
                  <div className="login-form bg-light mt-4 p-4">
                        <form action="" method="" className="row g-3" onSubmit={this.onSubmit.bind(this)}>
                           <h4>EasyFine Login</h4>
                           <div className="col-12">
                              <label>Num. Matricola</label>
                              <input type="text" name="username" 
                                     className="form-control" placeholder="Numero matricola" 
                                     value = {this.state.cid || ''}
                                     onChange = {this.changeText.bind(this, "cid")}/>
                           </div>
                           <div className="col-12">
                              <label>Password</label>
                              <InputGroup>
                      <input
                        type={this.state.showPassword ? "text" : "password"}
                        name="password"
                        className="form-control"
                        placeholder="Password"
                        autoComplete="on"
                        value={this.state.password}
                        onChange={this.changeText.bind(this, "password")}
                      />
                      <Button
                        onClick={() =>
                          this.setState({
                            showPassword: !this.state.showPassword,
                          })
                        }
                      >
                        {this.state.showPassword ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-eye-slash-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
                            <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-eye-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                          </svg>
                        )}
                      </Button>
                    </InputGroup>
                           </div>
                           <div className="col-12">
                              <label>C.F Azienda</label>
                              <input type="text" name="cfAzienda" 
                                       className="form-control" placeholder="codice fiscale Azienda"
                                       value = {this.state.cfAzienda}
                                       onChange = {this.changeText.bind(this, "cfAzienda")}
                              />
                           </div>
                        
                           <div className="col-12">
                              <br/>
                              <button type="submit" className="btn btn-dark" onClick={this.login.bind(this)}>Login</button>
                              <br/>
                              {successMessage}
                              {errorMessage}
                           </div>
                             
                        </form>
                        <hr className="mt-4"/>
                        
                  </div>
               </div>
            </div>
            <br/> <br/>
            <br/> <br/>
         </div>
        
      ); 
   } 
}